import styled from "styled-components";

export default styled.h1`
  font-size: 30px;
  font-weight: bold;
  margin-top: 24px;
`
